// @flow
import type { AxiosError } from "../helpers/types";
import type { AuctionsData } from "../reducers/auctions";

export const INVALIDATE_AUCTIONS = "INVALIDATE_AUCTIONS";
export const invalidateAuctions = () => ({ type: INVALIDATE_AUCTIONS });

export const REQUEST_AUCTIONS = "REQUEST_AUCTIONS";
export const requestAuctions = (locale: string) => ({
  type: REQUEST_AUCTIONS,
  locale
});

export const REQUEST_AUCTIONS_SUCCESS = "REQUEST_AUCTIONS_SUCCESS";
export const requestAuctionsSuccess = (data: AuctionsData) => ({
  type: REQUEST_AUCTIONS_SUCCESS,
  data
});

export const REQUEST_AUCTIONS_FAILED = "REQUEST_AUCTIONS_FAILED";
export const requestAuctionsFailed = (error: AxiosError) => ({
  type: REQUEST_AUCTIONS_FAILED,
  error
});

export const REQUEST_AUCTION = "REQUEST_AUCTION";
export const requestAuction = (auction: number, locale: string) => ({
  type: REQUEST_AUCTION,
  auction,
  locale
});

export const REQUEST_AUCTION_SUCCESS = "REQUEST_AUCTION_SUCCESS";
export const requestAuctionSuccess = (data: AuctionsData) => ({
  type: REQUEST_AUCTION_SUCCESS,
  data
});

export const REQUEST_AUCTION_FAILED = "REQUEST_AUCTION_FAILED";
export const requestAuctionFailed = (error: AxiosError) => ({
  type: REQUEST_AUCTION_FAILED,
  error
});



// WEBPACK FOOTER //
// ./src/redux/actions/auctions.js